import { ChangeEvent, useState } from "react";
import { MdSearch } from "react-icons/md";
import Select, { SingleValue } from 'react-select'
import { isAlphaNumeric } from "../utils/utils";
import { ISelectOption } from "utils/types";
import { set } from 'react-datepicker/dist/date_utils';

const SearchBox = (props: any) => {
    const [search, setSearch] = useState<ISelectOption>()
    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [endDate, setEndDate] = useState<Date | null>(new Date());

    const handleSearch = (option: SingleValue<ISelectOption>) => {
        if (option) {
            setSearch(option)
            props.onChange(option)
        }
    }
    const handleDateChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { id,value } = e.target
        if (id === 'startDate') {
            setStartDate(new Date(value))
        }
        if (id === 'endDate') {
           setEndDate(new Date(value))
        }
        setSearch({label: 'date', value: { startDate, endDate }})
        props.onChange({label: 'date', value: { startDate, endDate }})
    }
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        
        if (search) {
            props.onSearch(search)
        }

    }
    return (
      <form
        className={props.className}
        onSubmit={handleSubmit}>
        {props.options && props.options.length > 0 ? (
          <Select
            options={props.options}
            isSearchable
            className='w-full ps-4 py-2 border-0 text-start'
            onChange={handleSearch}
            defaultValue={props.options[0]}
          />
        ) : (
          <>
            <input
              id='startDate'
              name='startDate'
              onChange={handleDateChange}
              type='date'
              placeholder='Pick a date'
              defaultValue={props.defaultValue}
              className='form-control text-mutedText px-4 w-full ps-4 py-2 border-0 text-start focus:border-accent focus:ring-accent'
            />
            <input
              id='endDate'
              name='endDate'
              onChange={handleDateChange}
              type='date'
              placeholder='To'
              defaultValue={props.defaultValue}
              className='form-control text-mutedText px-4 w-full ps-4 py-2 border-0 text-start focus:border-accent focus:ring-accent'
            />
          </>
        )}
        <button
          type='submit'
          className='bg-primary text-white rounded-full w-10 h-10 hover:bg-primaryLight'>
          <MdSearch className='text-2xl mx-auto' />
        </button>
      </form>
    );
}
export default SearchBox;